import { AppRoutePath, ReporterRoutePath } from 'config/constants';
import { useMemo } from 'react';
import { useMatch } from 'react-router-dom';

export const useReporterMatch = (subPath?: ReporterRoutePath, opts?: { end?: boolean }) => {
  const path = subPath && opts?.end ? `${AppRoutePath.REPORTER}/${subPath}` : AppRoutePath.REPORTER;
  const blankPath =
    subPath && opts?.end
      ? `${AppRoutePath.REPORTER_BLANK}/${subPath}`
      : AppRoutePath.REPORTER_BLANK;

  const end = opts?.end ?? true;
  // Stable patterns let useMatch reuse its memoized match across renders.
  const pattern = useMemo(() => ({ path, end }), [path, end]);
  const blankPattern = useMemo(() => ({ path: blankPath, end }), [blankPath, end]);
  const match = useMatch(pattern);
  const blankMatch = useMatch(blankPattern);

  return match ?? blankMatch;
};
